export default {
  baseCDNUrl: process.env.NEXT_PUBLIC_CDN_URL,
}
